import {
  useEncounterId,
  useIsEncounterCompleted,
  useIsEncounterFinalizing,
} from "@src/features/encounters/state/encounterActor";
import { navigation } from "@src/navigation";
import { BriefingPage } from "@src/pages/PatientDetail/pages/BriefingPage";
import { Navigate } from "react-router-dom";
import { usePatientLayoutContext } from "../layouts/patient";

export function meta() {
  return [
    { title: "Briefing" },
    { name: "description", content: "Patient clinical briefing" },
  ];
}

export default function PatientBriefingRoute() {
  const { patientId } = usePatientLayoutContext();
  const encounterId = useEncounterId();

  const isEncounterFinalizing = useIsEncounterFinalizing();
  const isEncounterCompleted = useIsEncounterCompleted();

  if (
    (isEncounterFinalizing || isEncounterCompleted) &&
    patientId &&
    encounterId
  ) {
    return (
      <Navigate
        to={navigation.patientEncounter(patientId, encounterId.toString())}
      />
    );
  }

  return <BriefingPage />;
}
